export const team = `<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 429.569 429.569" style="enable-background:new 0 0 429.569 429.569;" xml:space="preserve">
<g>
	<path d="M248.574,132.122c14.029-10.38,23.146-27.039,23.146-45.791c0-31.395-25.541-56.936-56.936-56.936
		s-56.936,25.541-56.936,56.936c0,18.752,9.117,35.411,23.146,45.791C155.554,144.644,138,170.831,138,201.051v61.71
		c0,12.86,8.313,23.814,19.849,27.771v86.48c0,12.771,10.39,23.161,23.161,23.161h67.55c12.771,0,23.161-10.39,23.161-23.161v-86.48
		c11.536-3.957,19.849-14.911,19.849-27.771v-61.71C291.569,170.832,274.015,144.644,248.574,132.122z M214.785,48.395
		c20.917,0,37.936,17.018,37.936,37.936c0,20.918-17.018,37.936-37.936,37.936c-20.918,0-37.936-17.018-37.936-37.936
		C176.849,65.413,193.867,48.395,214.785,48.395z M272.569,262.761c0,5.743-4.703,10.409-10.459,10.348
		c-5.23-0.055-9.389,4.429-9.389,9.659v94.245c0,2.298-1.863,4.161-4.161,4.161h-19.667c-2.545,0-4.608-2.063-4.608-4.608v-80.303
		c0-5.06-3.818-9.478-8.867-9.805c-5.533-0.358-10.133,4.024-10.133,9.479v80.629c0,2.545-2.063,4.608-4.608,4.608H181.01
		c-2.298,0-4.161-1.863-4.161-4.161v-94.244c0-5.23-4.159-9.714-9.389-9.659C161.703,273.17,157,268.504,157,262.761v-60.833
		c0-31.71,25.18-58.171,56.887-58.655c32.272-0.492,58.682,25.616,58.682,57.777V262.761z"/>
	<path d="M85.133,156.619c8.541-7.795,13.909-19.011,13.909-31.458c0-23.488-19.109-42.596-42.597-42.596
		s-42.597,19.108-42.597,42.596c0,12.447,5.368,23.663,13.909,31.458C11.158,166.458,0,184.547,0,205.202v43.057
		c0,9.493,5.696,17.681,13.849,21.328v58.387c0,10.494,8.538,19.032,19.032,19.032h47.13c10.494,0,19.031-8.538,19.031-19.032
		v-58.387c8.153-3.646,13.848-11.834,13.848-21.327v-43.057C112.89,184.547,101.732,166.458,85.133,156.619z M32.849,125.16
		c0-13.011,10.585-23.596,23.597-23.596s23.597,10.585,23.597,23.596c0,13.011-10.585,23.597-23.597,23.597
		S32.849,138.171,32.849,125.16z M93.89,248.259c0,2.397-1.951,4.348-4.348,4.348c-5.247,0-9.5,4.253-9.5,9.5l-0.031,65.898
		l-14.065-0.01v-56.59c0-5.247-4.253-9.5-9.5-9.5s-9.5,4.253-9.5,9.5v56.577l-14.097-0.01v-65.866c0-5.247-4.253-9.5-9.5-9.5
		c-2.398,0-4.349-1.951-4.349-4.348v-43.057c0-20.647,16.798-37.445,37.445-37.445c20.647,0,37.445,16.798,37.445,37.445V248.259z"
		/>
	<path d="M401.812,156.619c8.541-7.795,13.909-19.011,13.909-31.458c0-23.488-19.109-42.596-42.597-42.596
		s-42.597,19.108-42.597,42.596c0,12.447,5.368,23.663,13.909,31.458c-16.599,9.839-27.757,27.928-27.757,48.583v43.057
		c0,9.493,5.696,17.681,13.849,21.328v58.387c0,10.494,8.538,19.032,19.032,19.032h47.13c10.494,0,19.031-8.538,19.031-19.032
		v-58.387c8.153-3.646,13.849-11.834,13.849-21.328v-43.057C429.569,184.547,418.411,166.458,401.812,156.619z M349.527,125.16
		c0-13.011,10.585-23.596,23.597-23.596s23.597,10.585,23.597,23.596c0,13.011-10.585,23.597-23.597,23.597
		S349.527,138.171,349.527,125.16z M410.569,248.259c0,2.397-1.951,4.348-4.349,4.348c-5.247,0-9.5,4.253-9.5,9.5l-0.031,65.898
		l-14.065-0.01v-56.59c0-5.247-4.253-9.5-9.5-9.5s-9.5,4.253-9.5,9.5v56.577l-14.097-0.01v-65.866c0-5.247-4.253-9.5-9.5-9.5
		c-2.398,0-4.349-1.951-4.349-4.348v-43.057c0-20.647,16.798-37.445,37.445-37.445s37.445,16.798,37.445,37.445V248.259z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
`;
